<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">
            {{ account ? account.name : 'Agency' }}
          </h4>
        </div>
      </div>
    </div>

    <div class="p-4 lg:p-12">
      <div class="max-w-5xl mx-auto">
        <nav class="border-b-2 border-gray-400">
          <RouterLink
            :to="{
              name: 'accounts.accountId.agencies.agencyUuid',
              params: {
                ...$route.params,
              },
            }"
            class="font-medium py-3 border-b-2 border-gray-400 text-gray-500 inline-block -mb-2px hover:border-gray-700 hover:text-gray-700"
            exact-active-class="border-blue-700 text-gray-900"
          >
            Details
          </RouterLink>
          <RouterLink
            :to="{
              name: 'accounts.accountId.agencies.agencyUuid.movements',
              params: {
                ...$route.params,
              },
            }"
            class="font-medium py-3 border-b-2 border-gray-400 text-gray-500 inline-block ml-4 -mb-2px hover:border-gray-700 hover:text-gray-700"
            exact-active-class="border-blue-700 text-gray-900"
          >
            Movements
          </RouterLink>
        </nav>
        <div class="mt-12">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { middleware } from '@/routes/guards';
import store from '@/store';

export default {
  beforeRouteEnter(to, from, next) {
    const check = middleware('account-permission:read agencies');

    check(to, from, async (args) => {
      if (typeof args !== 'undefined') {
        return next(...args);
      }

      const { agencyUuid: clientAgencyUuid } = to.params;

      try {
        await store.dispatch('ui/clientAgencies/read', { clientAgencyUuid });
        return next();
      } catch (error) {
        return next(false);
      }
    });
  },

  computed: {
    ...mapGetters('ui/clientAgencies', ['clientAgency']),
    ...mapState('entities', {
      account({ accounts }) {
        return accounts.byId[this.clientAgency.account_uuid];
      },
    }),
  },
};
</script>
